export const OFFERINGS_PATH = '/pga-coach/bookings/offerings'

export const OFFERINGS_TAB = {
  BOOKING_TYPE: 0,
  GROUP_EVENTS: 1,
}

export const getOfferingsPath = (tab = OFFERINGS_TAB.BOOKING_TYPE) =>
  tab === OFFERINGS_TAB.GROUP_EVENTS
    ? `${OFFERINGS_PATH}?tab=group-events`
    : OFFERINGS_PATH

export const parseOfferingsTab = search => {
  const tab = new URLSearchParams(search).get('tab')

  if (tab === 'group-events') {
    return OFFERINGS_TAB.GROUP_EVENTS
  }

  if (tab === 'booking-type') {
    return OFFERINGS_TAB.BOOKING_TYPE
  }

  return null
}
